'use client';

import { createChartIsland } from '@/components/charts/_shared/createChartIsland';
import {
  RED_LIST_INDEX_MAX_WIDTH_2XL_REM,
  RED_LIST_INDEX_MAX_WIDTH_REM,
} from '@/constants/layout';
import { RED_LIST_INDEX_ASPECT_RATIO } from '@/constants/stateCharts';

import type { RedListIndexChartProps } from '@/content/data/charts/red-list-index';
import type { CSSProperties } from 'react';

const styleVars = {
  '--chart-aspect-ratio': String(RED_LIST_INDEX_ASPECT_RATIO),
  '--chart-max-width': `${RED_LIST_INDEX_MAX_WIDTH_REM}rem`,
  '--chart-max-width-2xl': `${RED_LIST_INDEX_MAX_WIDTH_2XL_REM}rem`,
} as CSSProperties;

/**
 * Client boundary for the below-fold Red List Index chart.
 * Code-splits visx; defers import until near the viewport.
 */
export const RedListIndexChartIsland = createChartIsland<RedListIndexChartProps>(
  {
    loader: () =>
      import('./RedListIndexChart').then((mod) => mod.RedListIndexChart),
    loadingAriaLabel: 'Loading Red List Index chart',
    styleVars,
  },
);
